import RxProductContainer from "./RxProductContainer";

export default RxProductContainer;
